import { UserSettingDetailPage } from "@/features/user-setting/pages/UserSettingDetailPage";

const UserSettingDetail = () => {
  return <UserSettingDetailPage />;
};

export default UserSettingDetail;
